import { getWechatOpenId, queryUser } from "@/api/pm";
import { useUniExtend } from "@/hooks/useUniExtend";
import { loginWechat } from "@/utils/wechat";
import { useLocalStorage } from "@vueuse/core";
import { defineStore } from "pinia";
import { computed, ref, watch } from "vue";
import { useRequest } from "vue-request";
import { getLocationQuery, message } from '@/utils/common'

export const useWechatPublic = defineStore("wechatPublic", () => {
  // ref('ov14-5gwlFQ_BIgyy9QIQ4auA44w');
  const openId = useLocalStorage<string | undefined>("openid", "");

  const checkLoginLoading = ref(true);
  const isRegister = ref(false);
  const meetingInfoId = ref('');
  const emptyUserinfo = ref();
  const initUserInfo = ref();
  const newPhysician = ref(true);//是否新医生

  const userInfoFetched = ref(false)

  const { data: userInfo, run: fetchUserinfo} = useRequest(
    async () => {
      // console.log('lai le mede ', openId.value)
      if (!openId.value) return;
      // if (initUserInfo.value) return initUserInfo.value;
      const res = await queryUser(openId.value);
      if (!res) {
        newPhysician.value = true;
        emptyUserinfo.value = true;
        if (window.location.href.indexOf('/pagesMp/register/index') == -1) {
          toLeaveUserinfo();
        }
      }
      // initUserInfo.value = res;
      if (res && !res.wx_regist_time) {// 注册时间为空也需要进行注册
        newPhysician.value = true;
        if (window.location.href.indexOf('/pagesMp/register/index') == -1) {
          toLeaveUserinfo();
        }
      }
      if (res && (res.physician_name || res.physician_id)) {
        newPhysician.value = false;
      }
      checkLoginLoading.value = false
      // console.info(res, '微信医生');
      return res;
    },
    {
      onSuccess: data =>{
        userInfoFetched.value = true
      },
      refreshDeps: [openId],
    }
  );

  // code 换 openid
  const exchangeOpenId = async (code: string) => {
    //return 'ov14-5jfgMnSvANYSLtUoeaEbfpw';
    const res = await getWechatOpenId(code);
    if (res) {
      openId.value = res;
      return res;
    }
    return res;
  };

  const toLeaveUserinfo = () => {
    let rUrl = ''
    let meeting_info_id = getLocationQuery('meeting_info_id')
    let physican_id = getLocationQuery('physican_id')
    // 临时解决
    if (window.location.href.indexOf('redirect_route') > -1 && !meeting_info_id) {
      let rroute = new URL(location.href).searchParams.get('redirect_route')
      let redirectUrl = window.origin + rroute
      meeting_info_id = new URL(redirectUrl).searchParams.get('meeting_info_id');
    }
    // 邀请时未注册 isSinIn: 2 邀请标识 1 签到标识
    if (window.location.href.indexOf('/pagesMp/meeting-detail/index') > -1) {
      rUrl = `isSinIn=2&meeting_info_id=${meeting_info_id}&physican_id=${physican_id}`
    }
    // 签到时未注册
    if (window.location.href.indexOf('/pagesMp/checkin/index') > -1) {
      rUrl = `isSinIn=1&meeting_info_id=${meeting_info_id}`
    }
    // if (window.location.href.indexOf('/pagesMp/register/index') == -1) {
    //   alert("您尚未注册，请先注册");
    //   uni.navigateTo({
    //     url: `/pagesMp/register/index?${rUrl}`,
    //   });
    // }
  };

  const isLogin = computed(() => {
    return openId.value && localStorage.getItem("token");
  });

  const loginRedirect = loginWechatRedirect

  // 检查是否需要登录，需要则跳转登录
  const checkLogin = () => {
    // 绑定的医生 id
    const physicianId = getLocationQuery('physican_id');
    const token = localStorage.getItem('token')
    if (!openId.value || !token) {
      if (window.location.href.indexOf(':3000') > -1) {
        console.info('localhost');
      } else {
        loginRedirect()
      }
    }
    // watch(emptyUserinfo, (value) => {
    //   if (value) {
    //     alert("您尚未注册，请先注册");
    //     toLeaveUserinfo();
    //   }
    // });
  };

  const weichatLogin = () => {
    let weichatOpenid = window.localStorage.getItem("weichatOpenid");
    if (!weichatOpenid) {
      loginRedirect();
    }
  };

  const checkLeaveMessage = () => {};

  return {
    userInfoFetched,
    loginRedirect,
    userInfo,
    fetchUserinfo,
    openId,
    exchangeOpenId,
    emptyUserinfo,
    checkLogin,
    weichatLogin,
    newPhysician,
    isRegister,
    meetingInfoId,
    checkLoginLoading,
    isLogin,
  };
});

export const loginWechatRedirect = () => {
  let rUrl = window.location.pathname + window.location.search;
  loginWechat({ redirectRoute: rUrl });
};
